import { TOGGLE_SIDE_PANEL } from 'modules/SidePanel/store/types'

export const actionToggleSidePanel = (id) => ({
  type: TOGGLE_SIDE_PANEL,
  payload: { id },
})
